module.exports = __webpack_public_path__ + "static/media/chant.40960604.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/media/sound/chant.mp3
// module id = 197
// module chunks = 0